import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Sticker } from "@/components/Stickers";
import { SEO, breadcrumbLd, faqLd, webPageLd } from "@/lib/seo";

const faqs = [
  { q: "What is DoppelCrush?", a: "DoppelCrush is a playful, selfie-first dating and social discovery app. You upload one selfie and we surface people whose faces look like yours (Doppel Mode) or are the opposite of yours (Chaos Mode). It's free, light, and made to be shared with friends." },
  { q: "What's a DoppelCrush?", a: "That crush who looks just enough like you that everyone gets it. Same face card energy. We use a face-similarity signal to surface them." },
  { q: "What's Chaos Mode?", a: "Chaos Mode is the opposite of your usual type. We surface people who land in a 'deliberately unlike you' contrast band — wildly more interesting first dates than your usual algorithm." },
  { q: "How does the face match work?", a: "Your selfie runs through the open-source face-api.js library inside YOUR browser to compute a 128-number embedding. Only those numbers are sent to our server — never any biometric template a third party could use to identify you." },
  { q: "Do you store my selfie?", a: "Yes, in private object storage scoped to your profile. We never share it outside the app. Delete your account and we wipe the photo, embedding and all your data immediately." },
  { q: "Is DoppelCrush 18+?", a: "Yes. You must be 18 or older. We verify age during onboarding and remove anyone we find to be under 18." },
  { q: "Can I match with the same gender?", a: "Yes. Pick Women, Men or Everyone during onboarding — and switch any time from Profile." },
  { q: "What is a Doppel Room?", a: "A Doppel Room is a group reveal experience. Share the link in a group chat — each friend who joins gets their own Doppel + Chaos pick, and we crown the strongest twin, the wildest chaos pick and the funniest reveal in the room. We never compare friends face-to-face inside the room." },
  { q: "How do referrals work?", a: "Share your invite code from /invite or any match reveal. When a friend signs up, you both unlock extra daily matches and Chaos boosts." },
  { q: "Is it free?", a: "Yes — the core experience (selfie upload, swiping, matches, Doppel Rooms, twin-share pages) is completely free." },
  { q: "How do I delete my data?", a: "Go to Profile → Delete account. We wipe your selfie, embedding, swipes, matches and messages immediately. You can also email hello@doppelcrush.com to request a manual deletion." },
];

const TITLE = "FAQ";
const DESC =
  "Frequently asked questions about DoppelCrush — how the face match works, Doppel Mode vs Chaos Mode, privacy, and how Doppel Rooms work.";

export default function FAQ() {
  return (
    <div className="crush-bg min-h-screen" data-testid="faq-page">
      <SEO
        title={TITLE}
        description={DESC}
        path="/faq"
        jsonLd={[
          webPageLd({ title: TITLE, description: DESC, path: "/faq" }),
          breadcrumbLd([
            { name: "Home", path: "/" },
            { name: "FAQ", path: "/faq" },
          ]),
          faqLd(faqs),
        ]}
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-16">
        <Header />
        <div className="crush-frame mt-4 p-6 sm:p-10 relative">
          <Sticker kind="bolt" size={64} className="absolute -top-6 -right-4 rotate-12" color="#8a5cf6" />
          <h1 className="font-display text-5xl font-bold text-slate-900">FAQ</h1>
          <p className="mt-2 text-slate-600 font-body">Common questions about DoppelCrush — answered straight.</p>

          <Accordion type="single" collapsible className="mt-6">
            {faqs.map((item, i) => (
              <AccordionItem value={`q-${i}`} key={item.q} className="border-b-2 border-slate-100">
                <AccordionTrigger className="font-display text-lg text-slate-900 hover:no-underline" data-testid={`faq-q-${i}`}>{item.q}</AccordionTrigger>
                <AccordionContent className="font-body text-slate-600">{item.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
      <Footer />
    </div>
  );
}
